import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import { admissionApplicationService } from '../services/admissions/admissionApplicationService';
import type { ApplicationSiblings } from '../services/peopleService';

/**
 * The applicant's siblings at the school. `version` is anything that changes
 * when the application does (its `updatedAt`) — the list is fetched again
 * then, e.g. after the family is linked. Nothing is fetched while it is null.
 */
export const useApplicationSiblings = (applicationId: string, version: string | null | undefined) => {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState<ApplicationSiblings | null>(null);

  useEffect(() => {
    if (!version) return;
    let cancelled = false;
    admissionApplicationService.getSiblings(applicationId)
      .then(result => { if (!cancelled) setData(result); })
      .catch((err: any) => {
        if (cancelled) return;
        setData(null);
        enqueueSnackbar(err?.message || 'Could not check for siblings', { variant: 'error' });
      });
    return () => { cancelled = true; };
  }, [applicationId, version, enqueueSnackbar]);

  return data;
};
